import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'directories.filters-v2.main.flags.delete.success.title',
		defaultMessage: '{name} was deleted',
		description:
			'Title of the flag shown in Filters Directory when the request for deleting a filter succesed',
	},
});

const deleted = ({ name }: { name: string }): FlagConfiguration => ({
	type: 'success',
	title: [messages.title, { name }],
	isAutoDismiss: true,
	messageId: 'filters-main.flags.delete.flag.success',
	messageType: 'transactional',
});

export default deleted;
